(ns storrito.instagram.story.editor.tag-validation
  (:require [app.util.api-request :as api]
            [cljs.core.async :refer [<!] :as a])
  (:require-macros [cljs.core.async.macros :refer [go]]))

(defn ig-username-validation
  [username]
  (go
    (<! (api/request
          {:request-method :post
           :url "/api/ig-username-search"
           :transit-params {:username username}}))))
